// @flow
import React, { PureComponent } from 'react';

import { dynamicClassName } from 'utils/dynamicClassName';
import type { LogeListType } from 'types/LogeList';

type Props = {
  renderItems: Function,
  list: Array<LogeListType>,
};

type State = {
  index: number,
};

class Carousel extends PureComponent<Props, State> {
  state: State = {
    index: 0,
  };

  _renderItems = () => {
    const { list, renderItems } = this.props;

    if (list) {
      return list.map<any>((loge) => renderItems(loge));
    }

    return null;
  }

  _changeIndex = (nextIndex: number): void => {
    const maxIndex = this._getMaxLength();


    if (nextIndex >= 0 && nextIndex < maxIndex) {
      this.setState({ index: nextIndex });
    }
  }

  _getMaxLength = () => {
    const { list } = this.props;

    return list.length;
  }

  render() {
    const { index } = this.state;
    const maxIndex = this._getMaxLength();
    
    const previousButton = dynamicClassName('btn btn--icon');
    index === 0 && previousButton.add('is-disabled');
    const nextButton = dynamicClassName('btn btn--icon');
    index ===  (maxIndex - 1) && nextButton.add('is-disabled');

    return (
      <div className='carousel'>
        <div className="carousel__nav">
          <a
            role='button'
            tabIndex={0}
            onClick={() => this._changeIndex(index - 1)}
            className={previousButton.build()}
            title="Précédent">
            <i className="icon icon-arrow-left "></i>
          </a>
          <a
            role='button'
            tabIndex={0}
            onClick={() => this._changeIndex(index + 1)}
            className={nextButton.build()}
            title="Suivant">
            <i className="icon icon-arrow-right "></i>
          </a>
        </div>
        <div className="carousel__wrapper" style={{ transform: `translateX(${(index) * (-532)}px)` }}>
          {this._renderItems()}
        </div>
      </div>
    );
  }
}

export default Carousel;
